import { React, Link, useLocation } from "../../common";
import { useEffect, useState } from 'react';
import Navbar from "./Navbar";
import TopRight from "./TopRight";

const HomeHeader = (props) => {
  return (
    <header className="header">
      <div className="widthfix">
        <div className="logo">
          <Link to="/">
            <div className="uttaranaLogo logoPosition"></div>
          </Link>
        </div>

        <div className="Nav_RightContentBlk">
          <TopRight />

          <div className="topnav">
            <Navbar {...props}/>
          </div>
        </div>
      </div>
    </header>
  );
};

const InHeader = (props) => {
  return (
    <header className="headerInpage">
      <div className="widthfix">
        <div className="logo">
          <Link to="/">
            <div className="uttaranaLogo logoPosition"></div>
          </Link>
        </div>
        <div className="Nav_RightContentBlk">
          <TopRight />

          <div className="topnav">
            <Navbar {...props}/>
          </div>

        </div>
      </div>
    </header>
  );
};

const ResponsiveHeader = (props) => {
  return (
    <header className="headerResponsive" >
      <div className="navBlockResponsive">
        <div className='headerTopRight'>
          <TopRight />
        </div>

        <div className="topnav" id="myTopnav">
          <Link to="/">
            <div className="uttaranaLogo logoPosition"></div>
          </Link>

          <Navbar  {...props}/>
          <Link
            to="#"
            className="icon"
            onClick={() => window.myFunction()}
          ></Link>
        </div>
      </div>
    </header>
  );
};

const Component = (props) => {
  const { type } = props;
  const loc = useLocation().pathname;
  const [isResponsive, setIsResponsive] = useState(window.innerWidth < 999);

  useEffect(() => {
    const handleResize = () => {
      setIsResponsive(window.innerWidth < 999);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (isResponsive) {
    return (
      <>
        <ResponsiveHeader loc={loc} {...props} />
      </>
    );
  }

  return (
    <>
      {type === 'inner' ? (
        <InHeader loc={loc} {...props} />
      ) : (
        <HomeHeader loc={loc} {...props} />
      )}
    </>
  );
};

export default Component;

// import { React, Link, useLocation } from "../../common";
// import { useEffect, useState } from 'react';
// import Authentication from "../auth";
// import Navbar from "./Navbar";
// import TopRight from "./TopRight";

// const HomeHeader = (props) => {


//   return (
//     <header className="header">
//       <div className="widthfix">
//         <div className="logo">
//           <Link to="/">
//             <div className="uttaranaLogo logoPosition"></div>
//           </Link>
//         </div>

//         <div className="Nav_RightContentBlk">
//           <TopRight />

//           <div className="topnav">
//             <Navbar {...props}/>
//           </div>
//         </div>
//       </div>
//     </header>
//   );
// };

// const InHeader = (props) => {
//   return (
//     <header className="headerInpage">
//       <div className="widthfix">
//         <div className="logo">
//           <Link to="/">
//             <div className="uttaranaLogo logoPosition"></div>
//           </Link>
//         </div>
//         <div className="Nav_RightContentBlk">
//           <TopRight />

//           <div className="topnav">
//             <Navbar {...props}/>
//           </div>

//         </div>
//       </div>
//     </header>
//   );
// };

// const ResponsiveHeader = (props) => {
//   return (
//     <header className="headerResponsive" >
//       <div className="navBlockResponsive">
//         <div className='headerTopRight'>
//           <TopRight />
//         </div>

//         <div className="topnav" id="myTopnav">
//           <Link to="/">
//             <div className="uttaranaLogo logoPosition"></div>
//           </Link>

//           <Navbar  {...props}/>
//           <Link
//             to="#"
//             className="icon"
//             onClick={() => window.myFunction()}
//           ></Link>
//         </div>
//       </div>
//     </header>
//   );
// };

// const Component = (props) => {
//   const { type } = props;
//   const loc = useLocation().pathname;
//   const [isResponsive, setIsResponsive] = useState(window.innerWidth < 999);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsResponsive(window.innerWidth < 999);
//     };

//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   if (isResponsive) {
//     return (
//       <>
//         <ResponsiveHeader loc={loc} {...props} />
//         <Authentication />
//       </>
//     );
//   }

//   return (
//     <>
//       {type === 'inner' ? (
//         <InHeader loc={loc} {...props} />
//       ) : (
//         <HomeHeader loc={loc} {...props} />
//       )}
//       <Authentication />
//     </>
//   );
// };

// export default Component;